"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable no-loop-func */
/* eslint-disable no-restricted-syntax */

/**
 * calculates the locations  of the footnotes within the given node array
 * this is used to check if a footnote is actually inside a node after line breaking and splitting
 *
 * @param {Array} nodes
 * @returns Array
 */
function calculateFootnoteLocations(nodes) {
  var notes = [];
  var str = '';
  for (var _iterator = _createForOfIteratorHelperLoose(nodes), _step; !(_step = _iterator()).done;) {
    var item = _step.value;
    var text = '';
    if (item.type === 'TEXT') {
      text = item.children.map(function (e) {
        return e.value;
      }).reduce(function (a, b) {
        return a + b;
      }, '');
    }
    if (item.type === 'TEXT_INSTANCE') {
      text = item.value;
    }
    str += text;
    if (item.props && item.props.footnote) {
      notes.push({
        loc: str.length,
        el: item,
        ref: text
      });
    }
    if (item.children) {
      var calculatedOutput = calculateFootnoteLocations(item.children);
      var childNotes = calculatedOutput.notes.map(function (r) {
        return (0, _extends2.default)({}, r, {
          loc: r.loc + str.length
        });
      });
      if (childNotes.length > 0) str += calculatedOutput.childString;
      notes.push.apply(notes, childNotes);
    }
  }
  return {
    notes: notes,
    str: str
  };
}

/**
 * Finds all footnotes in a given node
 * checks if a footnote is actually present in the calculated lines of a node
 *
 * @param {Object} node
 * @param {number} top
 * @returns
 */
function getFootnotes(node, top) {
  var _node$box, _node$props;
  if (top === void 0) {
    top = 0;
  }
  var parentTop = top || 0;
  var nodeTop = ((_node$box = node.box) === null || _node$box === void 0 ? void 0 : _node$box.top) || 0;
  if ((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.footnote) {
    return [{
      el: node,
      loc: 0,
      approxTop: top,
      approxBottom: top + node.box.height
    }];
  }
  var footnotes = [];
  if (!node.children) return [];
  if (node.lines) {
    var _node$props2, _node$props3;
    var widows = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.widows) || 2;
    var orphans = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.orphans) || 2;
    var _calculateFootnoteLoc = calculateFootnoteLocations(node.children),
      calculatedNotes = _calculateFootnoteLoc.notes;
    var notes = [];
    var topUpto = nodeTop + parentTop;
    var previousLines = 0;
    var _loop = function _loop(i) {
      var line = node.lines[i];
      if (i - 1 >= 0) previousLines += node.lines[i - 1].string.length + 1;
      notes.push.apply(notes, calculatedNotes.filter(
      // check if the footnote is present within a line
      function (e) {
        return e.loc - e.ref.length < line.string.length + previousLines && e.loc - e.ref.length >= previousLines;
      }).map(function (r) {
        return (0, _extends2.default)({}, r, {
          approxTop: topUpto,
          approxBottom: topUpto + line.box.height,
          // line should not become a widow or orphan if broken before or after
          breakAfter: i + 1 === node.lines.length || node.lines.length - (i + 1) >= orphans && i + 1 >= widows,
          breakBefore: i === 0 || node.lines.length - i >= orphans && i >= widows
        });
      }));
      topUpto += line.box.height;
    };
    for (var i = 0; i < node.lines.length; i += 1) {
      _loop(i);
    }
    return notes;
  }
  for (var _iterator2 = _createForOfIteratorHelperLoose(node.children), _step2; !(_step2 = _iterator2()).done;) {
    var child = _step2.value;
    footnotes.push.apply(footnotes, getFootnotes(child, nodeTop + parentTop));
  }
  return footnotes;
}
var _default = exports.default = getFootnotes;